import api from '../utils/api';

// Fetch all teacher grades
export const getTeacherGrades = async (headers) => {
  try {
    const response = await api.get('/api/teachers',  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher grades:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific teacher grade by ID
export const getTeacherGradeById = async (id, headers) => {
  try {
    const response = await api.get(`/api/teachers/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error fetching teacher grade by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Create a new teacher grade
export const createTeacherGrade = async (teacherGradeData, headers) => {
  try {
    const response = await api.post('/api/teachers', teacherGradeData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating teacher grade:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing teacher grade
export const updateTeacherGrade = async (id, teacherGradeData, headers) => {
  try {
    const response = await api.put(`/api/teachers/${id}`, teacherGradeData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error updating teacher grade:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a teacher grade
export const deleteTeacherGrade = async (id, headers) => {
  try {
    const response = await api.delete(`/api/teachers/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error deleting teacher grade:', error.response ? error.response.data : error.message);
    throw error;
  }
};
